// extracted by mini-css-extract-plugin
export var InvestmentServicesContainer = "InvestmentServices-module--InvestmentServicesContainer---xz1I";
export var FlipCardContainer = "InvestmentServices-module--FlipCardContainer--EEZh2";